import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from '@app/components/shared/base-modal/base-modal.component';
import { LargeModalContent } from '@app/utils/interfaces/content.interface';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-large-modal',
  standalone: true,
  imports: [BaseModalComponent, TranslateModule],
  templateUrl: './large-modal.component.html',
  styleUrl: './large-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LargeModalComponent {
  private readonly currentDialogRef = inject(MatDialogRef<LargeModalComponent>);
  protected readonly viewDetails = inject(MAT_DIALOG_DATA) as LargeModalContent;

  protected close(): void {
    this.currentDialogRef.close();
  }
}
